// Small display formatters used across admin pages.

/**
 * Cents → "1.234.567" (IDR thousand-separator, no currency prefix).
 * Mirrors api/src/modules/billing/service.ts::formatRupiah so admin + push
 * notifications render identical strings. 1 IDR = 100 cents.
 */
export function formatRupiah(cents: number): string {
  const idr = Math.floor(cents / 100);
  return idr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** "YYYY-MM-DD" → locale-friendly date (no time component). */
export function formatDate(yyyymmdd: string): string {
  // Parse as local date, not UTC (date-only strings in JS Date are UTC midnight,
  // which can shift a day in non-UTC zones).
  const [y, m, d] = yyyymmdd.split('-').map(Number);
  if (!y || !m || !d) return yyyymmdd;
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('id-ID', { dateStyle: 'medium' });
}

/** "YYYY-MM" → "Oktober 2026", or "Okt 2026" with `short`. */
export function formatMonth(ym: string, short = false): string {
  const [y, m] = ym.split('-').map(Number);
  if (!y || !m) return ym;
  return new Date(y, m - 1, 1).toLocaleDateString('id-ID', { month: short ? 'short' : 'long', year: 'numeric' });
}

/** ISO datetime → locale-friendly date+time. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('id-ID', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
